import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { getClientConfig } from '../../config/clientConfig';
import HELPERS from '../../utils/helper';
import { Toast, toastMsgConfig } from '../toast';
import apis from '../../config/apis';
import './template15.css';

class EnquiryTemplate15 extends Component {
  constructor(props) {
    super(props);
    const clientConfig = getClientConfig(props.clientId);

    if (!clientConfig) {
      this.state = {
        loader: false,
        clientConfig: null,
        formData: {},
        errors: {},
        disabled: true,
        standardOptions: [],
        standardsLoading: false,
      };
      return;
    }

    this.state = {
      loader: false,
      formData: {
        enquiryDate: new Date().toISOString().split('T')[0],
        time: new Date().toTimeString().slice(0, 5),
        standard: '',
        mode: '',
        name: '',
        parentName: '',
        schoolName: '',
        coachingClass: '',
        currentAddress: '',
        motherOccupation: '',
        parentProfession: '',
        phone: '',
        parentContact: '',
        referredBy: ''
      },
      errors: {},
      disabled: false,
      clientConfig: clientConfig,
      standardOptions: [],
      standardsLoading: false,
      submitMessage: null,
      showSuccessPopup: false,
    };
  }

  componentDidMount() {
    if (this.state.clientConfig) {
      this.fetchStandards();
    }
  }

  fetchStandards = async () => {
    const { clientConfig } = this.state;
    this.setState({ standardsLoading: true });
    try {
      const url = `${clientConfig.api.baseUrl}${clientConfig.api.endpoints.getStandards.replace('{instituteId}', clientConfig.instituteId)}`;
      const res = await axios.get(url, {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Accept': 'application/json, text/plain, */*',
          'Timezone': 'Asia/Calcutta'
        }
      });
      const activeStandards = (res.data || [])
        .filter(s => s.is_active === 'Y')
        .sort((a, b) => a.standard_priority - b.standard_priority);
      this.setState({ standardOptions: activeStandards, standardsLoading: false });
    } catch (error) {
      console.error('Failed to fetch standards:', error);
      this.setState({ standardsLoading: false });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: { ...prevState.formData, [name]: value },
      errors: { ...prevState.errors, [name]: '' }
    }));
  }

  handleModeChange = (e) => {
    this.setState(prevState => ({
      formData: { ...prevState.formData, mode: e.target.value },
      errors: { ...prevState.errors, mode: '' }
    }));
  }

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};
    if (!formData.name.trim()) errors.name = 'Student name is required';
    if (!formData.phone.trim()) errors.phone = 'Phone number is required';
    else if (!/^[0-9]{10}$/.test(formData.phone)) errors.phone = 'Enter a valid 10-digit number';
    if (!formData.parentContact.trim()) errors.parentContact = 'Parent contact is required';
    else if (!/^[0-9]{10}$/.test(formData.parentContact)) errors.parentContact = 'Enter a valid 10-digit number';
    if (!formData.standard) errors.standard = 'Please select a standard';
    if (!formData.mode) errors.mode = 'Select a mode';
    if (!formData.parentName.trim()) errors.parentName = 'Parent name is required';
    if (!formData.schoolName.trim()) errors.schoolName = 'School name is required';
    if (!formData.coachingClass.trim()) errors.coachingClass = 'Coaching class is required';
    if (!formData.currentAddress.trim()) errors.currentAddress = 'Address is required';
    if (!formData.motherOccupation.trim()) errors.motherOccupation = "Mother's profession is required";
    if (!formData.parentProfession.trim()) errors.parentProfession = "Father's profession is required";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.validateForm()) return;
    this.setState({ loader: true, disabled: true });

    try {
      const { clientConfig, formData } = this.state;
      const headers = {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Content-Type': 'application/json',
          'source': 'WEB',
          'accept': 'application/json, text/plain, */*'
        }
      };

      const customComponentList = [
        {
          label: 'How Do You Want To Join For Above Courses?',
          enq_custom_value: formData.mode
        },
        {
          label: "Mother's profession",
          enq_custom_value: formData.motherOccupation
        },
        {
          label: 'Coaching Class For X Std.',
          enq_custom_value: formData.coachingClass
        },
        {
          label: 'School For X or XI',
          enq_custom_value: formData.schoolName
        },
        {
          label: 'References If Any',
          enq_custom_value: formData.referredBy
        }
      ].filter(item => item.enq_custom_value);

      const payload = {
        name: formData.name,
        parentName: formData.parentName,
        mobile: formData.phone,
        standard: formData.standard,
        institute_id: clientConfig.instituteId,
        customComponentList: customComponentList,
        address: formData.currentAddress,
        parentOccupation: formData.parentProfession,
        parentMobile: formData.parentContact
      };

      const apiUrl = apis.getApiUrl(clientConfig);
      const res = await HELPERS.ApiCall(apiUrl, payload, 'POST', 'proctur', headers);

      if (res.status === 200 || res.status === 201) {
        Toast('Application submitted successfully! We will contact you shortly.', toastMsgConfig('s'));
        this.setState({
          formData: {
            enquiryDate: new Date().toISOString().split('T')[0],
            time: new Date().toTimeString().slice(0, 5),
            standard: '', mode: '', name: '', parentName: '',
            schoolName: '', coachingClass: '', currentAddress: '',
            motherOccupation: '', parentProfession: '', phone: '',
            parentContact: '', referredBy: ''
          },
          loader: false, disabled: false,
          showSuccessPopup: true,
          submitMessage: { type: 'success', text: 'Application submitted successfully! We will contact you shortly.' }
        });
      } else {
        Toast('Unable to submit. Please try again.', toastMsgConfig('e'));
        this.setState({ loader: false, disabled: false, submitMessage: { type: 'error', text: 'Unable to submit. Please try again.' } });
      }
    } catch (error) {
      Toast('Submission failed. Please try again later.', toastMsgConfig('e'));
      this.setState({ loader: false, disabled: false, submitMessage: { type: 'error', text: 'Submission failed. Please try again later.' } });
    }
  }

  render() {
    const { formData, errors, disabled, loader, clientConfig, standardOptions, standardsLoading, submitMessage, showSuccessPopup } = this.state;
    if (!clientConfig) return null;

    return (
      <div className="t15">
        {/* Top Bar */}
        <header className="t15-topbar">
          <div className="t15-topbar-inner">
            <div className="t15-brand">
              <img src={clientConfig.branding.logo} alt={clientConfig.clientName} className="t15-logo" />
              <div>
                <h1 className="t15-brand-name">{clientConfig.clientName}</h1>
                {/* <p className="t15-brand-tagline">{clientConfig.branding.heroSubtitle}</p> */}
              </div>
            </div>
            <div className="t15-contact-bar">
              <a href={`tel:${clientConfig.contactInfo.phone1}`} className="t15-contact-chip">
                <i className="fa fa-phone"></i> {clientConfig.contactInfo.phone1}
              </a>
              <a href={`mailto:${clientConfig.contactInfo.email}`} className="t15-contact-chip">
                <i className="fa fa-envelope"></i> {clientConfig.contactInfo.email}
              </a>
            </div>
          </div>
        </header>

        {/* Form Card */}
        <main className="t15-main">
          <div className="t15-card">
            <div className="t15-card-header">
              <h2>Enquiry Form</h2>
              {/* <span className="t15-badge">{clientConfig.branding.badgeText}</span> */}
            </div>

            <form onSubmit={this.handleSubmit} className="t15-form">
              {/* Standard Selection */}
              <div className="t15-section">
                <div className="t15-section-label">Seeking Admission For <span className="req">*</span></div>
                <select
                  name="standard"
                  value={formData.standard}
                  onChange={this.handleChange}
                  className={`t15-input t15-select ${errors.standard ? 't15-input-err' : ''}`}
                  disabled={standardsLoading}
                >
                  <option value="">
                    {standardsLoading ? 'Loading...' : '-- Select --'}
                  </option>
                  {standardOptions.map(opt => (
                    <option key={opt.standard_id} value={opt.standard_name.trim()}>
                      {opt.standard_name.trim()}
                    </option>
                  ))}
                </select>
                {errors.standard && <span className="t15-err">{errors.standard}</span>}
              </div>

              {/* Mode */}
              <div className="t15-section">
                <div className="t15-section-label">How Do You Want To Join For Above Courses? <span className="req">*</span></div>
                <div className="t15-toggle-group">
                  <label className={`t15-toggle ${formData.mode === 'Offline' ? 'active' : ''}`}>
                    <input type="radio" name="mode" value="Offline" checked={formData.mode === 'Offline'} onChange={this.handleModeChange} />
                    <i className="fa fa-building"></i> Offline
                  </label>
                  <label className={`t15-toggle ${formData.mode === 'Online' ? 'active' : ''}`}>
                    <input type="radio" name="mode" value="Online" checked={formData.mode === 'Online'} onChange={this.handleModeChange} />
                    <i className="fa fa-laptop"></i> Online
                  </label>
                </div>
                {errors.mode && <span className="t15-err">{errors.mode}</span>}
              </div>

              <div className="t15-divider"></div>

              {/* Personal Details */}
              <div className="t15-section-heading"><i className="fa fa-user"></i> Personal Details</div>

              <div className="t15-row">
                <div className="t15-field">
                  <label>Student Name <span className="req">*</span></label>
                  <input type="text" name="name" value={formData.name} onChange={this.handleChange}
                    placeholder="Full name" className={`t15-input ${errors.name ? 't15-input-err' : ''}`} />
                  {errors.name && <span className="t15-err">{errors.name}</span>}
                </div>
                <div className="t15-field">
                  <label>Parent / Guardian Name <span className="req">*</span></label>
                  <input type="text" name="parentName" value={formData.parentName} onChange={this.handleChange}
                    placeholder="Parent or guardian name" className={`t15-input ${errors.parentName ? 't15-input-err' : ''}`} />
                  {errors.parentName && <span className="t15-err">{errors.parentName}</span>}
                </div>
              </div>

              <div className="t15-row">
                <div className="t15-field">
                  <label>School For X or XI <span className="req">*</span></label>
                  <input type="text" name="schoolName" value={formData.schoolName} onChange={this.handleChange}
                    placeholder="Current school name" className={`t15-input ${errors.schoolName ? 't15-input-err' : ''}`} />
                  {errors.schoolName && <span className="t15-err">{errors.schoolName}</span>}
                </div>
                <div className="t15-field">
                  <label>Coaching Class (X Std.) <span className="req">*</span></label>
                  <input type="text" name="coachingClass" value={formData.coachingClass} onChange={this.handleChange}
                    placeholder="Coaching class name" className={`t15-input ${errors.coachingClass ? 't15-input-err' : ''}`} />
                  {errors.coachingClass && <span className="t15-err">{errors.coachingClass}</span>}
                </div>
              </div>

              <div className="t15-field">
                <label>Current Address <span className="req">*</span></label>
                <textarea name="currentAddress" value={formData.currentAddress} onChange={this.handleChange}
                  placeholder="Full address" rows="2" className={`t15-input ${errors.currentAddress ? 't15-input-err' : ''}`}></textarea>
                {errors.currentAddress && <span className="t15-err">{errors.currentAddress}</span>}
              </div>

              <div className="t15-row t15-row-3">
                <div className="t15-field">
                  <label>Mother's Occupation <span className="req">*</span></label>
                  <select name="motherOccupation" value={formData.motherOccupation} onChange={this.handleChange}
                    className={`t15-input t15-select ${errors.motherOccupation ? 't15-input-err' : ''}`}>
                    <option value="">Select Occupation</option>
                    <option value="Business">Business</option>
                    <option value="Doctor">Doctor</option>
                    <option value="Engineer">Engineer</option>
                    <option value="Farmer">Farmer</option>
                    <option value="Govt. Worker">Govt. Worker</option>
                    <option value="Housewife">Housewife</option>
                    <option value="IT">IT</option>
                    <option value="Others">Others</option>
                  </select>
                  {errors.motherOccupation && <span className="t15-err">{errors.motherOccupation}</span>}
                </div>
                <div className="t15-field">
                  <label>Father Occupation <span className="req">*</span></label>
                  <select name="parentProfession" value={formData.parentProfession} onChange={this.handleChange}
                    className={`t15-input t15-select ${errors.parentProfession ? 't15-input-err' : ''}`}>
                    <option value="">Select Occupation</option>
                    <option value="Business">Business</option>
                    <option value="Doctor">Doctor</option>
                    <option value="Engineer">Engineer</option>
                    <option value="Farmer">Farmer</option>
                    <option value="Govt.Servant">Govt.Servant</option>
                    <option value="IT">IT</option>
                    <option value="Others">Others</option>
                  </select>
                  {errors.parentProfession && <span className="t15-err">{errors.parentProfession}</span>}
                </div>
                <div className="t15-field">
                  <label>References If Any</label>
                  <input type="text" name="referredBy" value={formData.referredBy} onChange={this.handleChange}
                    placeholder="Reference (if any)" className="t15-input" />
                </div>
              </div>

              <div className="t15-divider"></div>

              {/* Contact Details */}
              <div className="t15-section-heading"><i className="fa fa-phone"></i> Contact Details</div>

              <div className="t15-row">
                <div className="t15-field">
                  <label>Student Phone <span className="req">*</span></label>
                  <input type="tel" name="phone" value={formData.phone} onChange={this.handleChange}
                    placeholder="10-digit mobile" maxLength="10"
                    className={`t15-input ${errors.phone ? 't15-input-err' : ''}`} />
                  {errors.phone && <span className="t15-err">{errors.phone}</span>}
                </div>
                <div className="t15-field">
                  <label>Father/Mother Contact <span className="req">*</span></label>
                  <input type="tel" name="parentContact" value={formData.parentContact} onChange={this.handleChange}
                    placeholder="10-digit mobile" maxLength="10"
                    className={`t15-input ${errors.parentContact ? 't15-input-err' : ''}`} />
                  {errors.parentContact && <span className="t15-err">{errors.parentContact}</span>}
                </div>
              </div>

              {/* Submit Message */}
              {submitMessage && (
                <div className={`t15-submit-message ${submitMessage.type === 'success' ? 't15-success-msg' : 't15-error-msg'}`}>
                  {submitMessage.text}
                </div>
              )}

              {/* Submit */}
              <button type="submit" className="t15-submit" disabled={disabled || loader}>
                {loader ? (
                  <><i className="fa fa-spinner fa-spin"></i> Submitting...</>
                ) : (
                  <><i className="fa fa-paper-plane"></i> Submit Application</>
                )}
              </button>
            </form>
          </div>
        </main>

        {/* Success Popup */}
        {showSuccessPopup && (
          <div className="t15-popup-overlay">
            <div className="t15-popup">
              <div className="t15-popup-icon">
                <i className="fa fa-check-circle"></i>
              </div>
              <h3 className="t15-popup-title">Application Submitted!</h3>
              <p className="t15-popup-text">Thank you for your application. We will contact you shortly.</p>
              <a href="https://uwillclasses.com/" className="t15-popup-btn">
                <i className="fa fa-home"></i> Go to Home
              </a>
            </div>
          </div>
        )}

        {/* Footer */}
        <footer className="t15-footer">
          <div className="t15-footer-inner">
            <span><i className="fa fa-map-marker"></i> {clientConfig.contactInfo.address}</span>
            {clientConfig.contactInfo.website && (
              <span><i className="fa fa-globe"></i> {clientConfig.contactInfo.website}</span>
            )}
          </div>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ auth: state.auth });
const ConnectedEnquiryTemplate15 = connect(mapStateToProps)(EnquiryTemplate15);
export default ConnectedEnquiryTemplate15;
